import { useMatch } from 'react-router-dom';
import ROUTES from '../../../layout/routes';

export const useMatchedRoute = () => {
  const visualMatch = useMatch(ROUTES.flats.visual.root);
  const houseMatch = useMatch(ROUTES.flats.visual.house);
  const floorMatch = useMatch(ROUTES.flats.visual.floor);
  const bulkMatch = useMatch(ROUTES.flats.visual.bulk);

  if (floorMatch) return 'floor';
  if (houseMatch) return 'house';
  if (visualMatch) return 'visual';
  if (bulkMatch) return 'bulk';

  return null;
};
